// extracted by mini-css-extract-plugin
module.exports = {"countdown":"_8827"};